import { render } from "./UsersTicketNutrizionali.vue?vue&type=template&id=5cdf7ad2&scoped=true"
import script from "./UsersTicketNutrizionali.vue?vue&type=script&lang=js"
export * from "./UsersTicketNutrizionali.vue?vue&type=script&lang=js"

import "./UsersTicketNutrizionali.vue?vue&type=style&index=0&id=5cdf7ad2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdf7ad2"]])

export default __exports__